import '@/components/profileDropdown/styles/profile_avatar.scss';

import React from 'react';
import { connect } from 'react-redux';
import classNames from 'classnames';

import ProfileDayGoalChampion from '@/assets/images/wrapped/profile-day-goal-champion.svg';
import ProfileLetterPilot from '@/assets/images/wrapped/profile-letter-pilot.svg';
import ProfileMathSurfer from '@/assets/images/wrapped/profile-math-surfer.svg';
import ProfileWorldTraveller from '@/assets/images/wrapped/profile-world-traveller.svg';

import type { ProfileAvatarProps } from '@/components/profileDropdown/types';
import type { PlayerType } from '@/shared/types';

const PLAYER_TYPE_PROFILE_IMAGES: Record<PlayerType, string> = {
	day_goal_champion: ProfileDayGoalChampion,
	letter_pilot: ProfileLetterPilot,
	math_surfer: ProfileMathSurfer,
	traveller: ProfileWorldTraveller,
};

const ProfileAvatar = ({ userData }: ProfileAvatarProps) => {
	const { child_name, profile_emoji, player_type, settings } = userData || {};
	const { show_player_type_image } = settings || {};

	// If player_type exists, show the wrapped profile image
	if (player_type && show_player_type_image && PLAYER_TYPE_PROFILE_IMAGES[player_type]) {
		return (
			<div className="profile-avatar">
				<img
					src={PLAYER_TYPE_PROFILE_IMAGES[player_type]}
					alt={player_type}
					className="profile-avatar__image"
				/>
			</div>
		);
	}

	// Otherwise show letter/emoji
	const letter = profile_emoji?.emoji ? profile_emoji.emoji : child_name?.charAt(0) ?? '?';
	const color = profile_emoji?.emoji && profile_emoji?.color ? profile_emoji.color : '';

	return <div className={classNames('profile-avatar', color)}>{letter}</div>;
};

function mapStateToProps({ sharedReducer }: any) {
	return {
		userData: sharedReducer.userData,
	};
}

export default connect(mapStateToProps)(ProfileAvatar);
